import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
export default {
  name: 'IconBadge',
  props: {
    number: {
      type: Number,
      default: null
    }
  },
  setup: function setup(props) {
    var displayNumber = computed(function () {
      if (props.number === null) {
        return '0';
      }
      if (props.number > 99) {
        return '99+';
      }
      return props.number.toString();
    });
    return {
      displayNumber: displayNumber
    };
  }
};